import { render, staticRenderFns } from "./deliveryShippingDTable.vue?vue&type=template&id=e0bf0b92&scoped=true&"
import script from "./deliveryShippingDTable.vue?vue&type=script&lang=js&"
export * from "./deliveryShippingDTable.vue?vue&type=script&lang=js&"
import style0 from "./deliveryShippingDTable.vue?vue&type=style&index=0&id=e0bf0b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bf0b92",
  null
  
)

export default component.exports